import * as CardAction from './card.actionTypes';
import BoardService from '../services/board.service';
import { Dispatch } from 'react';
import {WbEventHandlerMixins} from '../../utils/common';
import moment from 'moment';
import BoardConst from '../utils/constants/board';
import { updateWsGraphData } from '../utils/board';
import { todayInProfileTimezone } from '../utils/currentDate';
import { is } from 'date-fns/locale';


const boardSevice = new BoardService();

export const addAICard = (columnId: string, payload: any) => async (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    try {
        console.log('addAICard');
        const {boardDetails, boardView} = getState();
        console.log('boardDetails', boardDetails);
        const {board={}, tagId, boardType, currentDate, user} = boardDetails;
        const today = todayInProfileTimezone(currentDate);
        const randNum = Math.floor(Math.random() * 10000000) + 1;
        const tempAiId = `newAi_${randNum}`;
        const stateVal = boardType == BoardConst.WS_BOARD_TYPE_PROGRESS ? columnId : 1;
        console.log('stateVal', stateVal);
        const stateText = WbEventHandlerMixins.getStateText(stateVal);
        console.log('stateText', stateText);
        const params: any = {
            JQ: "",
            xstate: stateText,
            aiDetEffort: 1,
            xrag: "green",
            priority: 3,
            wsBoardView: 1,
            type: payload.type,
            description: payload.description,
            addAiDueText: today.date,
            board: tagId,
            assign: user.id,
            due_date: today.date_formatted,
            boardColumn: columnId,
            uid: user.id,
            parent: payload.parent
          };
        console.log('params', params);
        const type = payload.parent ? 'subAi' : 'ai';
        let newAI: any = WbEventHandlerMixins.getTempAi(user, today.date_formatted, params.description, tempAiId, stateVal, type);
        newAI.owner = user.id;
        newAI.parent = payload.parent;
        console.log('newAI', newAI);
        dispatch({
            type: CardAction.ADD_AI_CARD,
            columnId,
            payload: newAI
        });
        if (payload.parent) {
            return;
        }
        const saveAI = await boardSevice.createAI(params);
        if (saveAI.data) {
            const {data} = saveAI.data;
            if (data) {
                dispatch({
                    type: CardAction.UPDATE_AI_CARD,
                    columnId,
                    id: tempAiId,
                    payload: data
                });
            }
            updateWsGraphData(tagId);
            // Set the margin on the relationships button if the Timeline button is visible
            if ($(".board-timeline-btn").length) {
                $(".workstream-relationship-wrapper").css({"margin-right": "200px", "padding-right": "20px"});
            }
        }
    }
    catch(e) {

    }
}

export const copyAICard = (payload: any) => (dispatch: any) => {
    dispatch({
        type: CardAction.COPY_AI_CARD,
        payload
    });
}

export const aiCardClick = (payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.AI_CARD_CLICK,
        columnId: payload.columnId,
        payload
    });
}

export const setMemberHighlighted = (memberId: string) => (dispatch: Dispatch<CardAction.CardActionTypes>) => {
    dispatch({
        type: CardAction.TIMELINE_MEMBER_HIGHLIGHTED,
        memberId
    });
}

export const changeAiDates = (task: any) => (dispatch: Dispatch<CardAction.CardActionTypes>) => {
    try {
        dispatch({
            type: CardAction.TIMELINE_DATE_CHANGED,
            value: task
        });
        const start_date = moment(task._start).format('MMM DD, YY');
        const due_date = moment(task._end).format('MMM DD, YY');
        boardSevice.updateAiDates({start_date, due_date, act_id: task.id, updateAll: ''});
    }
    catch(e) {

    } 
}

export const addCard = (columnId: string, items: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    try {
        const {boardDetails, boardView} = getState();
        const {board, boardType} = boardDetails;
        let cardType = BoardConst.BOARD_DATATYPE_ACTIONS;
        if (boardView == BoardConst.BOARD_VIEW_SHARED) {
            cardType = board.type;
        }
        dispatch({
            type: CardAction.ADD_CARD,
            columnId,
            cardType,
            items
        });
    }
    catch(e) {

    }
}

export const deleteCard = (columnId: string, id: string) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    try {
        const {boardDetails, boardView} = getState();
        const {board, boardType} = boardDetails;
        let cardType = 1;
        if (boardView == BoardConst.BOARD_VIEW_SHARED) {
            cardType = board.type;
            if (cardType == BoardConst.BOARD_DATATYPE_PEOPLE || cardType == BoardConst.BOARD_DATATYPE_WORKSTREAMS) {
                boardSevice.deleteBoardCard({id, columnId});
            }
        }
        dispatch({
            type: CardAction.DELETE_CARD,
            columnId,
            id,
            cardType
        });
    }
    catch(e) {

    }
}

export const updateCard = (columnId: string, id: string, item: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    try {
        const {boardDetails, boardView} = getState();
        const {board, boardType} = boardDetails;
        let cardType = 1;
        if (boardView == BoardConst.BOARD_VIEW_SHARED) {
            cardType = board.type;
        }
        dispatch({
            type: CardAction.UPDATE_CARD,
            columnId,
            id,
            cardType,
            item
        });
    }
    catch(e) {

    }
}

export const updateAiType = (id: string, type: number) =>
    (dispatch: Dispatch<CardAction.CardActionTypes>) => {
        dispatch({
            type: CardAction.UPDATE_AI_TYPE,
            id,
            aiType: type,
        });
        boardSevice.updateAiType(id, type);
    }

export const BoardUpdateS3Data = (payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.WS_BOARD_UPDATE_S3DATA,
        payload
    });
}
export const BoardFreeTextAdd = (payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.BOARD_FREETEXT_ADD,
        payload
    });
}
export const BoardFreeTextUpdate = (id: any, payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.BOARD_FREETEXT_UPDATE,
        payload,
        id
    });
}
export const BoardUpdateItemInColumn = (payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.BOARD_UPDATE_ITEM_IN_COLUMN,
        payload
    });
}
export const BoardDelteItemInColumn = (payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.BOARD_DELETE_ITEM_IN_COLUMN,
        payload
    });
}
export const updateBasedOnAIPopup = (payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.UPDATE_BASED_ON_AI_POPUP,
        payload
    });
}
export const updateRelationshipCounts = (payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.BOARD_UPDATE_RELATIONSHIP_COUNTS,
        payload
    });
}
export const BoardFreeTextUpdateImg = (id: any, payload: any) => (dispatch: Dispatch<CardAction.CardActionTypes>, getState: any) => {
    dispatch({
        type: CardAction.BOARD_FREETEXT_UPDATE_IMG,
        payload,
        id
    });
}